import React from 'react';
import './App.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { AdminProvider } from './context/AdminContext';
import LoginPage from './pages/LoginPage';
import ExplorePage from './pages/ExplorePage';
import FavoritesPage from './pages/FavoritesPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import MivChatbot from './components/MivChatbot';

// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminPlacesPage from './pages/admin/AdminPlacesPage';
import AdminRoutesPage from './pages/admin/AdminRoutesPage';
import AdminBusinessesPage from './pages/admin/AdminBusinessesPage';
import AdminCampaignsPage from './pages/admin/AdminCampaignsPage';
import AdminModerationPage from './pages/admin/AdminModerationPage';
import AdminBusinessClaimsPage from './pages/admin/AdminBusinessClaimsPage';

// Admin Route Guard
function AdminRouteGuard({ children }) {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}

// Router component to handle auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in hash (OAuth callback) - synchronous check
  if (location.hash?.includes('session_id=')) {
    return <AuthCallbackPage />;
  }
  
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<ExplorePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/explore" element={<ExplorePage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminRouteGuard><AdminLayout /></AdminRouteGuard>}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="places" element={<AdminPlacesPage />} />
        <Route path="routes" element={<AdminRoutesPage />} />
        <Route path="businesses" element={<AdminBusinessesPage />} />
        <Route path="business-claims" element={<AdminBusinessClaimsPage />} />
        <Route path="campaigns" element={<AdminCampaignsPage />} />
        <Route path="moderation" element={<AdminModerationPage />} />
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AdminProvider>
          <div className="App">
            <BrowserRouter>
              <AppRouter />
              <MivChatbot />
            </BrowserRouter>
          </div>
        </AdminProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
